import * as Sentry from '@sentry/browser';
import { Integrations } from '@sentry/tracing';

Sentry.init({
    dsn: 'https://8ad985a8ea694073912b6c1ae5124c3f@o264542.ingest.sentry.io/6053156',
    integrations: [new Integrations.BrowserTracing()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
});


if (!P3Portal) {
    P3Portal = {};
}
window.$ = window.jQuery = require('jquery');
window._ = require('underscore');
require('backbone');
require('parsleyjs');
require('jquery-ui/ui/widgets/sortable');
require('jquery-ui/ui/widgets/draggable');
require('jquery-ui/ui/widgets/datepicker');
require('jquery-ui/ui/widgets/dialog');
require('./vendor/jqueryui-timepicker-addon/dist/jquery-ui-timepicker-addon');
require('spectrum-colorpicker');
require('select2');
window.Noty = require('noty');
require('jquery-colorbox');
window.Tablesort = require('tablesort');
require('./helpers');
require('./init');
P3Portal.views = { ...require('./views.js').views };
require('./form.elements.js');
require('./nav.js');
require('./filters.js');
require('./proposal.js');
require('./app.js');
if (!P3Portal.defer) {
    $('document').ready(function () {
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                Accept: 'application/json',
            },
        });
        P3Portal.init();
    });
}
